export default [
  {
    path: '/admin/companies',
    name: 'company',
    meta: { requiresAuth: true },
    component: () => import('@/pages/corporate/company')
  }
]
